
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesTaxGrid extends Serenity.EntityGrid<ECommSalesTaxRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesTax'; }
        protected getIdProperty() { return ECommSalesTaxRow.idProperty; }
        protected getInsertPermission() { return ECommSalesTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesTaxRow.localTextPrefix; }
        protected getService() { return ECommSalesTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}